function init() {
    const observer = new IntersectionObserver(
        (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("animated");
                    observer.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.1 }
    );

    const svgElementMobile = document.querySelector("footer .image-wave-color.mobile svg");
    const svgElementDesktop = document.querySelector("footer .image-wave-color.desktop svg");

    if (svgElementMobile) {
        observer.observe(svgElementMobile);
    }

    if (svgElementDesktop) {
        observer.observe(svgElementDesktop);
    }
}

export default { init };
